var _path, _path2, _path3, _path4, _path5, _path6, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMango(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 511.989 511.989",
    style: {
      enableBackground: "new 0 0 511.989 511.989"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A0D468"
    },
    d: "M110.701,168.189c3.969-31.039-23.507-98.193-30.593-99.099 c-7.094-0.906-50.546,57.202-54.507,88.248c-3.961,31.038,11.883,58.631,35.382,61.631 C84.483,221.961,106.748,199.235,110.701,168.189z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#434A54"
    },
    d: "M13.476,187.196l-0.008,0.016c-0.891-0.25-1.828-0.391-2.805-0.391 C4.772,186.821,0,191.594,0,197.485c0,4.922,3.327,9.047,7.851,10.281v0.016c0.32,0.086,32.734,8.96,70.733,21.194l6.531-20.312 C46.671,196.298,13.805,187.29,13.476,187.196z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E9573F"
    },
    d: "M368.836,192.868c-53.374,1.289-117.403-69.358-175.965-69.381 c-98.076-0.039-137.286,97.7-124.091,166.582c13.195,68.857,66.452,113.639,181.871,109.967 c126.763-4.047,227.776-143.857,218.026-168.294C458.912,207.306,400.054,192.11,368.836,192.868z"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M466.287,227.281c-17.327,44.835-107.028,147.958-215.636,151.427C135.232,382.38,81.975,337.599,68.78,268.725 c-1.016-5.289-1.719-10.758-2.109-16.335c-0.883,12.983-0.172,25.757,2.109,37.679c13.195,68.857,66.452,113.639,181.871,109.967 c126.763-4.047,227.776-143.857,218.026-168.294C468.053,230.219,467.256,228.734,466.287,227.281z"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FC6E51"
    },
    d: "M383.992,442.909c70.687,0,127.997-57.295,127.997-127.997H255.995 C255.995,385.614,313.306,442.909,383.992,442.909z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFCE54"
    },
    d: "M383.992,432.237c64.796,0,117.325-52.529,117.325-117.325H266.659 C266.659,379.708,319.181,432.237,383.992,432.237z"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M458.646,314.912c0,0,0,0,0,0.016c0,5.875,4.781,10.656,10.672,10.656s10.672-4.781,10.672-10.656c0-0.016,0-0.016,0-0.016 H458.646z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M415.991,314.928c0,5.875,4.781,10.656,10.656,10.656c5.906,0,10.672-4.781,10.672-10.656c0-0.016,0-0.016,0-0.016h-21.328 C415.991,314.912,415.991,314.912,415.991,314.928z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M373.32,314.928c0,5.875,4.781,10.656,10.672,10.656c5.89,0,10.655-4.781,10.655-10.656c0-0.016,0-0.016,0-0.016H373.32 C373.32,314.912,373.32,314.912,373.32,314.928z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M330.649,314.928c0,5.875,4.781,10.656,10.672,10.656s10.672-4.781,10.672-10.656c0-0.016,0-0.016,0-0.016h-21.344 C330.649,314.912,330.649,314.912,330.649,314.928z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M287.994,314.928c0,5.875,4.781,10.656,10.655,10.656c5.906,0,10.672-4.781,10.672-10.656c0-0.016,0-0.016,0-0.016h-21.327 C287.994,314.912,287.994,314.912,287.994,314.928z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMango);
export default __webpack_public_path__ + "static/media/mango.6af2bcf0d6afca541a37252d6f150e54.svg";
export { ForwardRef as ReactComponent };